import { cn } from '@/shared/lib/cn';
import { Eye, EyeOff } from 'lucide-react';
import { forwardRef, useState, type ComponentProps } from 'react';
import { Input } from './input';

type Props = Omit<ComponentProps<typeof Input>, 'type'>;

/**
 * shadcn-react doesn't ship a password-input primitive. This wraps Input with
 * an eye-toggle, matching the Vue PasswordInput component the auth pages
 * relied on. Uses forwardRef so callers can focus the input on validation
 * errors.
 */
export const PasswordInput = forwardRef<HTMLInputElement, Props>(function PasswordInput({ className, ...props }, ref) {
    const [visible, setVisible] = useState(false);
    return (
        <div className="relative">
            <Input {...props} ref={ref} type={visible ? 'text' : 'password'} className={cn('pr-10', className)} />
            <button
                type="button"
                tabIndex={-1}
                aria-label={visible ? 'Сховати пароль' : 'Показати пароль'}
                className="absolute top-1/2 right-2 -translate-y-1/2 rounded p-1 text-muted-foreground transition-colors hover:text-foreground"
                onClick={() => setVisible((v) => !v)}
            >
                {visible ? <EyeOff className="size-4" /> : <Eye className="size-4" />}
            </button>
        </div>
    );
});
